import { useQuery } from '@tanstack/react-query';

import { search } from '../../../shared/api/magellan/search';
import type { SearchResponseDTO } from '../../../shared/api/magellan/search/dto';

export const useSearchQuery = (
  query: string,
): { data?: SearchResponseDTO; isLoading: boolean } => {
  const queryKey = [search.name, query];
  return useQuery({
    queryKey,
    queryFn: () => search({ q: query }),
    enabled: !!query.length && query.length > 2,
    placeholderData: previousData => previousData,
  });
};
